import React, { useState } from 'react';

// Hooks
import useUrlContains from '@src/hooks/useUrlContains';

// Comps
import AccountForm from '@project-stories/ecommerce/Account/AccountForm/AccountForm';
import AccountFormHeader from '@project-stories/ecommerce/Account/AccountFormHeader/AccountFormHeader';
import {Link} from '@arctheme-components/elements/Link/Link';

type Props = {
    section: any;
    signUpFields: any;
    headerColorSchema?: string;
};

export const Default = ({ section, signUpFields, headerColorSchema }: Props) => {
    const {
        // Header
        title_type,
        title_type_mobile,
        body_type,
        body_type_mobile,

        // Login
        title_login,
        tagline_login,

        // Register
        title_register,
        tagline_register,

        // Register CTA
        title_register_cta,
        tagline_register_cta,
        button_label_register_cta,
        button_style_register_cta
    } = section;

    // States
    const [showCustomFields, setShowCustomFields] = useState(true);

    // Hooks
    const isRegisterPage: boolean = useUrlContains('register');

    const showRegisterForm = true;

    // Form header settings
    const headerTitleType = `${title_type_mobile} ${title_type}-lg`;
    const headerTaglineType = `${body_type_mobile} ${body_type}-lg`;

    return (
        <>
            <div className='md:sticky top-[calc(var(--header-height)+1rem)]'>
                <AccountFormHeader
                    title={title_login || title_register}
                    titleType={headerTitleType}
                    tagline={tagline_login || tagline_register}
                    taglineType={headerTaglineType}
                    colorSchema={headerColorSchema}
                />

                <AccountForm
                    section={section}
                    isRegister={isRegisterPage}
                    showCustomFields={showCustomFields}
                    signUpFields={signUpFields}
                />
            </div>

        </>
    );
};

export default Default;